import React, { Fragment, useEffect,  useState } from 'react';
import { observer } from 'mobx-react';
import { Link, useNavigate } from 'react-router-dom';
import { formatDate, formatNumber } from '../../utils/helpers';
import { useStores } from '../../hooks/use-stores';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import SimpleTable from '../../components/super/SimpleTable';
import { FormControlLabel,  } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Box } from '@material-ui/core';
import { Fab } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import GreenCheckbox from '../../components/GreenCheckbox';
import Button from '@material-ui/core/Button';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import MrrChart from '../../components/MrrChart';
import { Chip, Typography } from '@mui/material';
import PartnerInfoWithPopover from '../../components/super/partnerInfoWithPopover';
import pluralize from 'pluralize';
import { BigModal, FlexDiv, ThemedButton } from '@awarego-ui/components';
import pick from 'lodash/pick'
import PartnerDuesModalContent from '../../components/super/PartnerDuesModalContent';

const useStyles = makeStyles((theme) => ({
    fab: {
        position: 'fixed',
        bottom: theme.spacing(4),
        right: theme.spacing(4),
    },
}));

function PartnersList() {
    const { superStore } = useStores();
    const { loadingPartners, partners, metricDates, updatingRecordPayment, updatingVoidPayment, modifyInvoiceError } = superStore;
    const classes = useStyles();
    const navigate = useNavigate();
    const [activeOnly, setActiveOnly] = React.useState(true);
    const [withCompanies, setWithCompanies] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedDateError, setSelectedDateError] = React.useState(null);
    const [selectedEntry, setSelectedEntry] = useState(null);
    console.log(selectedEntry)

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        superStore.loadPartners()
    };

    const handleChangeActiveOnly = (event) => {
        setActiveOnly(event.target.checked);
    };

    const handleModifyInvoice = async ({ partnerId, invoiceId, type }) => {
        const invoice = await superStore.modifyInvoice(invoiceId, partnerId, type);
        if (invoice && (invoice.status === 'paid' || invoice.status === 'voided')) {
            const updated = superStore.partners.find(p => p.id === partnerId);
            setSelectedEntry(updated);
        }
    };


    const handleChangeWithCompanies = (event) => {
        setWithCompanies(event.target.checked);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'Name',
                Cell: (x) => (
                    <Link to={`/partners/${x.row.original.id}`}>{x.value}</Link>
                ),
                accessor: 'name',
            },
            {
                Header: 'Created',
                accessor: 'created',
                Cell: (x) => formatDate(x.value),
            },
            {
                Header: 'MRR History',
                accessor: 'mrrMetrics',
                id: 'mrrChart',
                key: 'mrrChart',
                Cell: (x) => {
                    return (
                        <Box width={200} height={50} border={'1px solid green'}>
                            <MrrChart
                                partnerId={x.row.original.id}
                                metrics={x.value}
                            />
                        </Box>
                    );
                },
            },
            {
                Header: 'MRR',
                accessor: 'mrr_usd',
                id: 'mrr',
                key: 'mrr',
                Cell: (x) => {
                    const { currency, mrr, mrr_usd } = x.row.original;
                    const displayValue = `${formatNumber(mrr_usd || 0, 0)} USD`;
                    const isForeign = currency && currency !== 'USD';

                    const content = (
                        <span
                            style={{
                                textDecoration: isForeign ? 'underline dotted' : 'none',
                            }}
                        >
                            {displayValue}
                        </span>
                    );

                    return isForeign ? (
                        <Tooltip title={`${formatNumber(mrr || 0, 0)} ${currency}`} arrow>
                            {content}
                        </Tooltip>
                    ) : (
                        content
                    );
                },
            },

            {
                Header: 'Billing',
                id: 'billing',
                Cell: (x) => {
                    const { customBilling, customerLink, warnSubscriptions } = x.row.original;

                    if (!customerLink) {
                        return 'Custom';
                    }

                    return (
                        <Box display="flex" alignItems="center" gap={1}>
                            <a href={customerLink} target="_blank" rel="noreferrer">
                                {customBilling ? 'Custom' : 'Chargebee'}
                            </a>
                            {warnSubscriptions && <WarningIcon color="error" />}
                        </Box>
                    );
                },
            },
            {
                Header: 'Subscriptions',
                accessor: 'subscriptions',
                Cell: (x) => {
                    const subs = x.row.original.subscriptions || [];
                    if (!x.row.original.customerLink) return '';

                    return (
                        <Box display="flex" flexDirection="column" gap={3}>
                            {subs.map((sub) => {
                                const warnKey =
                                    sub.plan === 'Complete'
                                        ? 'warnComplete'
                                        : sub.plan === 'Training'
                                            ? 'warnTraining'
                                            : sub.plan === 'Assessment'
                                                ? 'warnAssessment'
                                                : null;

                                const warn = warnKey ? x.row.original[warnKey] : false;
                                const hasCoupons = Array.isArray(sub.coupons) && sub.coupons.length > 0;
                                const couponNames = hasCoupons
                                    ? sub.coupons.map((c) => c.coupon_id).join(', ')
                                    : '';

                                return (
                                    <Box
                                        key={sub.id}
                                        whiteSpace="nowrap"
                                        lineHeight="30px"
                                    >
                                        <Box
                                            display="inline-block"
                                            whiteSpace="nowrap"
                                            width={10}
                                            height={10}
                                            borderRadius={5}
                                            bgcolor={warn ? 'red' : 'green'}
                                            border="1px solid #444444"
                                        />{' '}
                                        <a
                                            href={sub.subscriptionLink}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {sub.plan}
                                        </a>
                                        {sub.due_invoices_count ? (
                                            <Tooltip
                                                title="Due invoices"
                                                aria-label="add"
                                                placement="left"
                                            >
                                                <Box display="inline" ml={0.5}>
                                                    ⏳ {sub.due_invoices_count}
                                                </Box>
                                            </Tooltip>
                                        ) : (
                                            ''
                                        )}
                                        , 💸{sub.nextBilling}
                                        {hasCoupons && (
                                            <Tooltip title={`Coupons: ${couponNames}`} arrow>
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    sx={{
                                                        ml: 1,
                                                        color: '#888',
                                                        fontSize: '0.75rem',
                                                        textDecoration: 'underline dotted',
                                                        cursor: 'default',
                                                    }}
                                                >
                                                    {sub.coupons.length} coupon
                                                    {sub.coupons.length > 1 ? 's' : ''}
                                                </Typography>
                                            </Tooltip>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    );
                },
            },
            {
                Header: 'Total Dues',
                accessor: (x) => x,
                id: 'dues',
                key: 'dues',
                Cell: (x) => {
                    const { totalDuesCount, totalDuesAmount } = x.row.original;

                    if (totalDuesCount > 0) {
                        return (
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" gap={1} onClick={ () => setSelectedEntry(x.row.original)} style={{cursor: 'pointer', textDecoration: 'underline'}}>
                                    <span role="img" aria-label="invoices">📑</span>
                                    {totalDuesCount} {pluralize('invoice', totalDuesCount)}
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <span role="img" aria-label="amount">💲</span>
                                    {totalDuesAmount}
                                </Box>
                            </Box>
                        );
                    }

                    return (
                        <Box display="flex" alignItems="center">
                            <Box
                                width={10}
                                height={10}
                                borderRadius="50%"
                                bgcolor="green"
                            />
                            <Typography variant="body2" style={{marginLeft: 5}}>No Dues</Typography>
                        </Box>
                    );
                },
            },
            {
                Header: 'Companies',
                accessor: 'company_count',
                Cell: (x) => {
                    const free = x.row.original.companiesFree;
                    const total = x.value;
                    return (
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">{formatNumber(total, 0)}</Typography>
                            {free > 0 && (
                                <Chip
                                    label={`${formatNumber(free, 0)} Free`}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        fontSize: '0.7rem',
                                        height: 20,
                                        borderColor: 'rgba(255, 193, 7, 0.5)',
                                        color: 'rgba(133, 100, 0, 0.8)',
                                        backgroundColor: 'rgba(255, 249, 230, 0.4)',
                                        ml: 0.75,
                                    }}
                                />
                            )}
                        </Box>
                    );
                },
            },
            {
                Header: 'Companies Active',
                accessor: 'companiesActive',
                Cell: (x) => {
                    const free = x.row.original.companiesFreeActive;
                    const total = x.value;
                    return (
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">{formatNumber(total, 0)}</Typography>
                            {free > 0 && (
                                <Chip
                                    label={`${formatNumber(free, 0)} Free`}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        fontSize: '0.7rem',
                                        height: 20,
                                        borderColor: 'rgba(255, 193, 7, 0.5)',
                                        color: 'rgba(133, 100, 0, 0.8)',
                                        backgroundColor: 'rgba(255, 249, 230, 0.4)',
                                        ml: 0.75,
                                    }}
                                />
                            )}
                        </Box>
                    );
                },
            },
            {
                Header: 'Seats Active',
                accessor: 'seatsActive',
                Cell: (x) => {
                    const free = x.row.original.seatsFreeActive;
                    const total = x.value;
                    return (
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">{formatNumber(total, 0)}</Typography>
                            {free > 0 && (
                                <Chip
                                    label={`${formatNumber(free, 0)} Free`}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        fontSize: '0.7rem',
                                        height: 20,
                                        borderColor: 'rgba(255, 193, 7, 0.5)',
                                        color: 'rgba(133, 100, 0, 0.8)',
                                        backgroundColor: 'rgba(255, 249, 230, 0.4)',
                                        ml: 0.75,
                                    }}
                                />
                            )}
                        </Box>
                    );
                },
            },
            {
                Header: 'Users Active',
                accessor: 'usersActive',
                Cell: (x) => {
                    const free = x.row.original.usersFreeActive;
                    const total = x.value;
                    return (
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">{formatNumber(total, 0)}</Typography>
                            {free > 0 && (
                                <Chip
                                    label={`${formatNumber(free, 0)} Free`}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        fontSize: '0.7rem',
                                        height: 20,
                                        borderColor: 'rgba(255, 193, 7, 0.5)',
                                        color: 'rgba(133, 100, 0, 0.8)',
                                        backgroundColor: 'rgba(255, 249, 230, 0.4)',
                                        ml: 0.75,
                                    }}
                                />
                            )}
                        </Box>
                    );
                },
            },

            {
                Header: 'Info',
                accessor: 'lms_domain',
                Cell: (x) => {
                    return (
                        <PartnerInfoWithPopover
                            partnerId={x.row.original.id}
                            partnerInfo={x.row.original}
                        />
                    );
                },
            },
        ],
        []
    );

    const handleExport = () => {
        if (!selectedDate) {
            return setSelectedDateError('Please select a date');
        }
        setSelectedDateError(null);
        superStore.exportPartners({
            activeOnly,
            selectedDate: selectedDate.format('YYYY-MM-DD'),
            withCompanies,
        });
    };

    return (
        <Grid
            container
            direction="row"
            justify="center"
            align="center"
            spacing={2}
        >
            <Grid item xs={12}>
                <Box mt={4} mb={2}>
                    <Typography variant="h2">Partners</Typography>

                    {/* Total MRR box */}
                    {!loadingPartners && partners?.length > 0 && (
                        <Box
                            mt={1.5}
                            px={2}
                            py={1}
                            display="inline-flex"
                            alignItems="center"
                            border="1px solid rgba(0,0,0,0.08)"
                            borderRadius={2}
                            sx={{
                                backgroundColor: 'rgba(245, 247, 250, 0.6)',
                                boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.04)',
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 500,
                                    color: '#555',
                                    mr: 1,
                                }}
                            >
                                Total Partners MRR (approx.):
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 600,
                                    color: 'primary.main',
                                }}
                            >
                                {formatNumber(
                                    partners.reduce((sum, p) => sum + (p.mrr_usd || 0), 0),
                                    0
                                )}{' '}
                                USD
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Grid>
            {loadingPartners ? (
                <ThemedSpinner />
            ) : (
                <Fragment>
                    <Tooltip
                        title="Create partner"
                        aria-label="add"
                        placement="left"
                    >
                <Fab
                    color="primary"
                    onClick={() => navigate('/partners/create')}
                    className={classes.fab}
                >
                    <AddIcon />
                </Fab>
                    </Tooltip>

                    {partners && partners.length > 0 && (
                        <Grid item xs={12}>
                            <SimpleTable
                                columns={columns}
                                data={partners.filter((p) => {
                                    return activeOnly ? p.enabled === 1 : true;
                                })}
                                needsFilter={true}
                                pageSize={100}
                                maxWith={2000}
                                extraFilter={
                                    <>
                                        <FormControlLabel
                                            control={
                                                <GreenCheckbox
                                                    checked={activeOnly}
                                                    onChange={
                                                        handleChangeActiveOnly
                                                    }
                                                    name="checkedG"
                                                />
                                            }
                                            label="Active only"
                                        />
                                        <Box
                                            display={'flex'}
                                            flexDirection={'column'}
                                        >
                                            <LocalizationProvider
                                                dateAdapter={AdapterMoment}
                                            >
                                                <DatePicker
                                                    value={selectedDate}
                                                    onChange={(newValue) => {
                                                        setSelectedDate(
                                                            newValue
                                                        );
                                                    }}
                                                    shouldDisableDate={(
                                                        day
                                                    ) => {
                                                        const candidate = day.format('YYYY-MM-DD');
                                                        return !metricDates.includes(candidate);
                                                    }}
                                                    helperText={
                                                        selectedDateError
                                                    }
                                                    error={!!selectedDateError}
                                                />
                                            </LocalizationProvider>
                                            {selectedDateError && (
                                                <Typography
                                                    color={'error'}
                                                    variant={'caption'}
                                                >
                                                    {selectedDateError}
                                                </Typography>
                                            )}
                                        </Box>
                                        <Button
                                            variant={'contained'}
                                            color={'primary'}
                                            onClick={handleExport}
                                        >
                                            Export
                                        </Button>
                                        <FormControlLabel
                                            control={
                                                <GreenCheckbox
                                                    checked={withCompanies}
                                                    onChange={
                                                        handleChangeWithCompanies
                                                    }
                                                    name="checkedG"
                                                />
                                            }
                                            label="With Companies"
                                        />
                                    </>
                                }
                            />
                        </Grid>
                    )}
                </Fragment>
            )}
            {selectedEntry && (
                <BigModal
                    ariaHideApp={false}
                    isOpen={!!selectedEntry}
                    onRequestClose={() => setSelectedEntry(null)}
                    heading={
                        <FlexDiv alignCenter>
                            Due Invoices for {selectedEntry.name}
                        </FlexDiv>
                    }
                    width={800}
                    modalContent={
                        <PartnerDuesModalContent
                            onClick={handleModifyInvoice}
                            entry={selectedEntry}
                            updatingRecordKeys={updatingRecordPayment}
                            updatingVoidKeys={updatingVoidPayment}
                            error={modifyInvoiceError}
                        />
                    }
                    modalFooterContent={
                        <ThemedButton
                            mode="secondary"
                            onClick={() => setSelectedEntry(null)}
                            text="Close"
                        />
                    }
                />
            )}
        </Grid>
    );
}

export default observer(PartnersList);
